import * as React from 'react';
import { Icon, message, Button  } from 'antd';

import "styles/customOrderFileUpload.scss";

class CustomOrderFileUpload extends React.Component<any, any> {
    // 上传附件
  onFileChange = event => {
    const input = event.target;
    // console.log(input)
    const files = input.files;
    if (files && files.length > 0) {
      const file = files[0];
      const fileSize = file.size;
      let size = fileSize / 1024;
      let type = file.type;
      if (type.indexOf("image/") != -1) {
        if (size > 1024) {
          message.warn("图片不能大于1M");
          input.value = "";
          return;
        }
      } else {
        if (size > 1024 * 10) {
          message.warn("附件不能大于10M");
          input.value = "";
          return;
        }
      }

      this.props.uploadFile({
        file: files[0],
        error: text => {
          message.error(text);
        },
        success: ({ name, type, url }) => {
          if(url){
            this.props.addUploadFile({ name, type, url })
          }
        }
      });
    }
  };

  removeFile = () => {
    this.props.addUploadFile(null);
  }

  getUploadState = () => {
    let { customerFile, customData } = this.props;
    if(customData && customData.file){

    }

    if(customerFile && customerFile.url || (customData && customData.file)){
      return (
        <React.Fragment>
          <div className={'customOrderFileUpload-left'}>
            <Icon type="check-circle" theme="filled" style={{color:'#389838',paddingRight:10}}/>
            已上传
          </div>
          {
            customData && customData.status != 1 && <Button type="primary" onClick={this.removeFile}>删除</Button>
          }
        </React.Fragment>
      )
    }else{
      if( customData && customData.status == 1){
        return (
          <div className={'customOrderFileUpload-left'}>
            <Icon type="exclamation-circle" theme="filled" style={{color:'red',paddingRight:10}}/>
            未上传
          </div>
        )
      }else{
        return (
          <React.Fragment>
            <div className={'customOrderFileUpload-left'}>
              <Icon type="exclamation-circle" theme="filled" style={{color:'red',paddingRight:10}}/>
              未上传
            </div>
            <Button type="primary" style={{padding:0}}>
                <label style={{ cursor: "pointer",padding:15 }}>
                  选取文件
                  <input
                    type="file"
                    name="guestInfoFile"
                    style={{ display: "none" }}
                    accept="image/*, image/*,application/msword,
                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                    application/vnd.ms-excel,	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                    text/plain
                    "
                    onChange={this.onFileChange}
                  />
                </label>
            </Button>
          </React.Fragment>
        )
      }
    }
  }
    
  render() {
    return (
      <div className={'customOrderFileUploadContainer'}>
        <div className={'customOrderFileUpload-title'}>
            <Icon type="snippets" />
            出行人信息
        </div>
        <div className={'customOrderFileUpload-content'}>
          { this.getUploadState()}
        </div>
      </div>
    )
  }
}

export default CustomOrderFileUpload;